
<c-auto-form config="notificationCtrl.autoFormConfig"></c-auto-form>

<div class="popup-button-content">
    <div>
        <span><button class="popup-msg-button btn-primary" ng-click="notificationCtrl.ok()"><span>{{'save'|translate}}</span></button></span>
        <span><button class="popup-msg-button" ng-click="notificationCtrl.remove()"><span>{{'optionNotification.remove'|translate}}</span></button></span>
        <span><button class="popup-msg-button" ng-click="notificationCtrl.cancel()"><span>{{'popup.cancel'|translate}}</span></button></span>

    </div>
</div>